import React from "react";
import ViewArtwork from "../components/ViewArtwork";
import Footer from "../components/footer";

const MarketPage = () => (
  <div>
    <section className="jumbotron breadcumb no-bg">
      <div className="mainbreadcumb">
        <div className="container">
          <div className="row m-10-hor">
            <div className="col-12">
              <h1 className="text-center">Marketplace</h1>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="items_filter"></div>
        </div>
      </div>
      <ViewArtwork />
    </section>

    <Footer />
  </div>
);
export default MarketPage;
